/**
 * @generated SignedSource<<9ffa015576de88a551269ac5133fa91d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "accountid",
        "variableName": "accountId"
      }
    ],
    "concreteType": "LookupOpenPayoutResult",
    "kind": "LinkedField",
    "name": "lookupopenpayout",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "payoutOpen",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "payoutAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "requestedDate",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OpenPayoutFetchQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OpenPayoutFetchQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "304c532fb2651ea142ed99598218c14a",
    "id": null,
    "metadata": {},
    "name": "OpenPayoutFetchQuery",
    "operationKind": "query",
    "text": "query OpenPayoutFetchQuery(\n  $accountId: UUID\n) {\n  lookupopenpayout(accountid: $accountId) {\n    payoutOpen\n    payoutAmount\n    requestedDate\n  }\n}\n"
  }
};
})();

node.hash = "bce0ca9d486a183316254e082b357098";

module.exports = node;
